import TitleDescription from "./title-description.component";

export default TitleDescription;
